/**
 * @prop --cbp-tag-color: var(--cbp-color-text-lighter);
 * @prop --cbp-tag-color-dark: var(--cbp-color-info-darker);
 * @prop --cbp-tag-color-background: var(--cbp-color-info-dark);
 * @prop --cbp-tag-color-background-dark: var(--cbp-color-info-light);
 */
 :root{
  --cbp-tag-color: var(--cbp-color-info-lighter);
  --cbp-tag-color-dark: var(--cbp-color-info-dark);
  --cbp-tag-color-background: var(--cbp-color-info-dark);
  --cbp-tag-color-background-dark: var(--cbp-color-info-lighter);
}


/* 
 * Dark Mode - display dark design based on mode or context
 */
[data-cbp-theme=light] cbp-tag[context*=dark]:not([context=light-always]),
[data-cbp-theme=dark] cbp-tag:not([context=dark-inverts]):not([context=light-always]) {
  --cbp-tag-color: var(--cbp-tag-color-dark) !important;
  --cbp-tag-color-background: var(--cbp-tag-color-background-dark) !important;
}

cbp-tag {
  display: inline-flex;
  gap: var(--cbp-space-1x);
  align-items: stretch;
  color: var(--cbp-tag-color);
  background-color: var(--cbp-tag-color-background);
  border-radius: var(--cbp-border-radius-pill);
  cursor: default;
  padding: 0 var(--cbp-space-3x);
  text-align: center;
  font-weight: var(--cbp-font-weight-medium);
  font-size: var(--cbp-font-size-subhead);
  line-height: var(--cbp-space-7x);
  width: fit-content;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  
  &[color=warning] {
    --cbp-tag-color: var(--cbp-color-text-darker);
    --cbp-tag-color-dark: var(--cbp-color-text-darker);

    --cbp-tag-color-background: var(--cbp-color-warning-base);
    --cbp-tag-color-background-dark: var(--cbp-color-warning-light);
  }

  &[color=success] {
    --cbp-tag-color: var(--cbp-color-success-lighter);
    --cbp-tag-color-dark: var(--cbp-color-success-dark);

    --cbp-tag-color-background: var(--cbp-color-success-dark);
    --cbp-tag-color-background-dark: var(--cbp-color-success-lighter);
  }

  &[color=danger] {
    --cbp-tag-color: var(--cbp-color-text-lightest);
    --cbp-tag-color-dark: var(--cbp-color-text-darkest);

    --cbp-tag-color-background: var(--cbp-color-danger-dark);
    --cbp-tag-color-background-dark: var(--cbp-color-danger-light);
  }
}
